module.exports = __webpack_public_path__ + "img/case-lg-5.fac7011e.jpg";